import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaExternalLinkAlt, FaBox } from 'react-icons/fa';
import axios from 'axios';

const API_URL = 'https://aamirsaba.com/api';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/products`)
      .then(response => {
        console.log('Products loaded:', response.data);
        setProducts(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading products:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="pt-32 pb-20 bg-darkNavy min-h-screen">
        <div className="container mx-auto px-6 text-center">
          <div className="text-cyan text-xl">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="pt-32 pb-20 bg-darkNavy min-h-screen">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-center mb-16">
          <h1 className="text-4xl md:text-6xl font-bold">Our <span className="text-cyan">Products</span></h1>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">Explore our software solutions and tools</p>
        </motion.div>

        {products.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-400 text-lg">No products available at the moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {products.map((product, index) => (
              <motion.div
                key={product.id || index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="bg-navy rounded-xl p-6 border border-gray-800 hover:border-cyan transition group"
              >
                <div className="text-4xl mb-4">
                  {product.icon || <FaBox className="text-cyan" />}
                </div>
                <span className="text-xs text-cyan uppercase tracking-wider">{product.category || 'General'}</span>
                <h3 className="text-xl font-semibold mt-2 text-white">{product.name}</h3>
                <p className="text-gray-400 text-sm mt-2">{product.description}</p>
                <a
                  href={product.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-4 text-cyan hover:text-cyan/80 font-medium hover:underline transition"
                >
                  Visit Product <FaExternalLinkAlt size={14} />
                </a>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Products;
